<template lang="html">
  <div class="wcc result-group">
    <slot></slot>
  </div>
</template>
<script>
  export default {
  }
</script>
<style lang="scss">

  .wcc.result-group {
    p {
      margin-bottom: 0;
      margin-top: 0;
    }
  }
</style>